angular.module('zc.zenclerkS')
  .component('zcsChartSingleBar', {
    bindings: {
      chartData: '<',
      chartLegend: '<',
    },
    controller: zcsChartSingleBarController
  });

zcsChartSingleBarController.$inject = ['$element', '$translate'];
function zcsChartSingleBarController($element, $translate) {
  const vm = this;
  const svgContainer = d3.select($element[0]).append('svg');
  let xAxisLength;
  let xAxisCounter;
  const chart = nv.models.discreteBarChart();

  vm.$onChanges = changes => {
    xAxisLength = vm.chartData[0].values.length;
    // do not react to dimension changes
    if(changes.chartData) {
      drawChart();
    }
  };

  // Draw a pie chart
  function drawChart() {
    xAxisCounter = 0;
    return nv.addGraph(function() {
      chart.duration(500)
        .color([angular.element($element[0]).css('color')])
        .x(d => moment(d.x, 'YYYY-MM-DD').valueOf())
        .y(d => d.y);

      if(vm.chartLegend || angular.isUndefined(vm.chartLegend)) {
        chart.margin({right: 0, bottom: 30})
          .xAxis.tickPadding(10);
      } else {
        chart.margin({top: 0, right: 0, bottom: 0, left: 0})
          .showXAxis(false)
          .showLegend(false)
          .showYAxis(false);
      }

      chart.xAxis.tickFormat(d => getDate(d));
      chart.yAxis.tickFormat(d3.format(',.0d'));

      svgContainer.datum(vm.chartData).transition().duration(500).call(chart);
      nv.utils.windowResize(chart.update);
      return chart;
    });
  }

  function getDate(timestamp) {
    xAxisCounter = xAxisCounter + 1;
    // reduce xAxis legends when there is too many data
    if((xAxisLength > 11) && (xAxisCounter % 4 !== 0) && (vm.chartLegend || angular.isUndefined(vm.chartLegend))) {
      return '';
    }
    return d3.time.format($translate.instant('sharedModules.dateTimeFormats.chart.monthDay'))(new Date(timestamp));
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/charts/chart_single_bar.js